import { NavLink, Outlet, useNavigate } from "react-router-dom";
import "./main-layout.scss";
import MAIN_LOGO from "../../assets/images/AIDA-logo.svg";
import { NavDropdown, ProgressBar } from "react-bootstrap";
import DATABASE from "../../assets/images/database.svg";
import BOOK from "../../assets/images/book.svg";
import LOGOUT from "../../assets/images/logout.svg";
import { useAuth } from "../../utility/use-auth";
import { useEffect, useState } from "react";
import { updateUserStatus } from "../../services/api.service";
import MediaService from "../../services/media.service";
import { MediaUsage } from "../../model/media-usage.model";
import { signOut } from "firebase/auth";
import { auth, db } from "../../firebase/auth.firebase";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import CustomSnackbar from "../snackbar/snackbar.component";
import { useSnackbar } from "../../utility/snackbar.utility";

const MainLayoutComponent = () => {
  const { snackbar, showSnackbar, hideSnackbar } = useSnackbar();
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  const [usage, setUsage] = useState<MediaUsage>();

  useEffect(() => {
    if (!loading && !user) {
      // If the user is not authenticated, redirect to login
      navigate("/login");
    }

    if (user) {
      fetchUsage();
    }
  }, [user, loading, navigate]);

  const clickMenu = () => { };

  const logout = async () => {
    try {
      if (!auth.currentUser) return; // Ensure user is logged in before logging out

      const user = auth.currentUser;

      // Log the logout action in Firestore
      const logRef = collection(db, "logs");
      await addDoc(logRef, {
        timestamp: serverTimestamp(),
        user_id: user.uid,
        user_email: user.email,
        action_type: "LOGOUT",
      });

      // Sign out from Firebase Auth
      await signOut(auth);

      showSnackbar("ออกจากระบบสำเร็จ", "success", 3000);
      navigate("/login"); // Redirect to login page after logout
    } catch (error: any) {
      showSnackbar("เกิดข้อผิดพลาดในการออกจากระบบ", "error", 3000);
    }
  };

  const fetchUsage = async () => {
    try {
      const response = await MediaService.getUsage();
      setUsage(response.data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const clickManual = () => {
    window.open(
      "https://drive.google.com/file/d/1BscUkS_ZXNIjaTvg_sq0ZkZhxd3NcNeV/view?usp=sharing",
      "_blank"
    );
  };

  return (
    <>
      {user && (
        <div className="main-layout-control">
          <div className="main-layout-header-control">
            <NavLink to="/">
              <img src={MAIN_LOGO} className="main-layout-header-logo"></img>
            </NavLink>
            <div className="main-layout-header-menu-control">
              <NavLink
                to="/"
                onClick={clickMenu}
                className={({ isActive }) =>
                  isActive
                    ? "main-layout-header-text-active"
                    : "main-layout-header-text"
                }
              >
                หน้าหลัก
              </NavLink>
              {(user.role == "Admin" || user.role == "Super Admin") && (
                <NavLink
                  to="/users-management"
                  onClick={clickMenu}
                  className={({ isActive }) =>
                    isActive
                      ? "main-layout-header-text-active"
                      : "main-layout-header-text"
                  }
                >
                  จัดการผู้ใช้งาน
                </NavLink>
              )}

              <NavDropdown
                title={user.email}
                id="basic-nav-dropdown"
                className="main-layout-header-text"
              >
                <div className="main-layout-header-menu-other-control">
                  {usage && (
                    <>
                      <div className="main-layout-header-menu-other-text-control">
                        <img
                          src={DATABASE}
                          className="main-layout-header-menu-other-text-img"
                        ></img>
                        <span className="main-layout-header-menu-other-text">
                          จำนวนการใช้งาน
                        </span>
                      </div>
                      <span className="main-layout-header-usage-bar-text">
                        {usage.total_usage_minutes}/{usage.max_limit_minutes}{" "}
                        นาที
                      </span>
                      <div className="main-layout-header-usage-bar-control">
                        <ProgressBar
                          className="main-layout-header-usage-bar"
                          now={
                            (usage.total_usage_minutes * 100) /
                            usage.max_limit_minutes
                          }
                        ></ProgressBar>
                      </div>
                      <div className="main-layout-header-menu-other-divider"></div>
                    </>
                  )}

                  <div
                    className="main-layout-header-menu-other-text-control"
                    onClick={clickManual}
                  >
                    <img
                      src={BOOK}
                      className="main-layout-header-menu-other-text-img"
                    ></img>
                    <span className="main-layout-header-menu-other-text">
                      คู่มือการใช้งาน
                    </span>
                  </div>

                  <div className="main-layout-header-menu-other-divider"></div>

                  <div
                    className="main-layout-header-menu-other-text-control"
                    onClick={logout}
                  >
                    <img
                      src={LOGOUT}
                      className="main-layout-header-menu-other-text-img"
                    ></img>
                    <span className="main-layout-header-menu-other-text">
                      ออกจากระบบ
                    </span>
                  </div>
                </div>
              </NavDropdown>
            </div>
          </div>
          <div className="main-layout-outlet-control">
            <Outlet />
          </div>

          <CustomSnackbar
            open={snackbar.open}
            message={snackbar.message}
            severity={snackbar.severity}
            duration={snackbar.duration}
            onClose={hideSnackbar}
          />
        </div>
      )}
    </>
  );
};

export default MainLayoutComponent;
